import { Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { VesselKPIDate } from '@operations/features/vesselVisitDashboard/components/molecules/VesselKPIDate'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface FirstMoveValue {
  discharge?: string | null
  load?: string | null
}

type VesselVisitMoveStatsProps =
  | {
      type: 'avgGrossProductivity' | 'estimatedHours'
      title: string
      subtitle?: string
      value?: number | null
    }
  | {
      type: 'firstMove'
      title: string
      subtitle?: string
      value?: FirstMoveValue | null
    }

const formatTime = (date: string) =>
  new Date(date).toLocaleTimeString([], {
    timeStyle: 'short',
    hour12: false,
  })

export const VesselVisitMoveStats = observer(
  ({ type, title, subtitle = '', value }: VesselVisitMoveStatsProps) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <Card sx={{ height: '100%' }}>
        <CardHeader title={<Typography variant='captionBold'>{title}</Typography>} />
        <CardContent>
          {type === 'firstMove' ? (
            <Stack direction='row' gap={theme.customSpacing.s}>
              <Stack flex={1}>
                <Typography variant='subtitle2' color={theme.palette.grey[600]}>
                  {t('discharge', 'Discharge')}
                </Typography>
                <VesselKPIDate date={value?.discharge} />
              </Stack>
              <Stack flex={1}>
                <Typography variant='subtitle2' color={theme.palette.grey[600]}>
                  {t('load', 'Load')}
                </Typography>
                <VesselKPIDate date={value?.load} />
              </Stack>
            </Stack>
          ) : (
            <Stack gap={theme.customSpacing.s}>
              <Typography variant='subtitle2' color={theme.palette.grey[600]}>
                {subtitle}
              </Typography>
              <Typography variant='h4'>{value ?? EmptyIndicator}</Typography>
            </Stack>
          )}
        </CardContent>
      </Card>
    )
  },
)
